import styled, { css } from 'styled-components';

export const QuizGlobalWrapper = styled.div`
  padding: 10px;
  background-color: ${(props) => props.theme.colors.white};

  .quiz-info {
    background: linear-gradient(178.31deg, #e9f3ff -11.67%, #f2f8ff 117.4%);
    padding: 10px 22px 23px;

    .duration {
      display: flex;
      align-items: center;
      gap: 35px;

      svg {
        margin-left: 7px;
        margin-top: -2px;
        stroke: ${(props) => props.theme.colors.textPrimary};
      }
    }
  }
`;

export const QuizContainer = styled.div`
  padding: 10px 32px 32px;
  overflow-y: auto;

  // scrollbar style
  /* width */
  &::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.brownGrey};
    border-radius: 10px;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: ${(props) => props.theme.colors.brownGrey};
  }
`;

export const QuizWrapper = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.colors.border};
  margin-bottom: 20px;

  & .correct {
    & label {
      background-color: ${(props) => props.theme.colors.success} !important;
      color: black !important;
      &[data-checked='true'] {
        box-shadow: 0px 0px 6px ${(props) => props.theme.colors.textPrimary};
      }
    }
  }

  & .wrong {
    & label {
      background-color: ${(props) => props.theme.colors.fail} !important;
      color: black !important;
      &[data-checked='true'] {
        box-shadow: 0px 0px 6px ${(props) => props.theme.colors.textPrimary};
      }
    }
  }

  &.resume {
    border: none;
  }
`;

export const Question = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 29px;
`;

export const AnswerWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 10px;
  row-gap: 24px;
  padding-bottom: 65px;

  @media ${(props) => props.theme.device.mobileL} {
    display: block;
  }

  &.resume {
    display: flex;
    justify-content: space-between;
    align-items: end;
    color: ${(props) => props.theme.colors.link};
    margin-bottom: 30px;
    cursor: pointer;

    .answer:not(:first-child) {
      margin-top: 12px;
    }
  }
`;

export const Answer = styled.div`
  label {
    color: ${(props) => props.theme.colors.textPrimary};
  }

  ${({ isCompleted }) =>
    isCompleted &&
    css`
      & .quiz {
        cursor: not-allowed;
      }
    `}
`;

export const ResultMessage = styled.div`
  padding: 24px 0 16px;
  color: ${(props) => props.theme.colors.textPrimary};
`;

export const ButtonContainer = styled.div`
  padding: 0 48px;
  display: flex;
  justify-content: space-between;
  width: 100%;

  button {
    margin: unset;
    width: 200px;
  }

  @media ${(props) => props.theme.device.mobileL} {
    justify-content: center;
    flex-wrap: wrap;
    gap: 20px;
    padding: 0;

    button {
      width: 100%;
    }
  }
`;

export const TabsWrapper = styled.div``;

export const ResultsWrapper = styled.div`
  padding: 60px 32px 32px;

  .result-msg-wrapper {
    display: flex;
    justify-content: center;
    gap: 32px;

    svg {
      stroke: ${(props) => props.theme.colors.fail};

      &.icon-face-smile {
        stroke: ${(props) => props.theme.colors.success};
      }
    }
  }

  .btn-wrapper {
    margin-top: 16px;
  }

  @media ${(props) => props.theme.device.mobileL} {
    padding: 24px 16px 0;
  }
`;

export const ProgressResult = styled.div`
  margin-top: 84px;
  padding-bottom: 143px;
  display: flex;
  justify-content: center;
  border-bottom: 0.5px solid #646464;

  .progress-wrapper {
    width: 80%;
    max-width: 800px;
    position: relative;
  }

  .answers {
    position: absolute;
    top: -4px;
    &.min {
      left: -45px;
    }
    &.max {
      right: -45px;
    }
  }

  @media ${(props) => props.theme.device.mobileL} {
    margin-top: 60px;
    padding-bottom: 110px;
    border-bottom: none;
  }
`;

export const Target = styled.div`
  position: absolute;
  top: 0;
  left: calc(${({ left }) => left}% - 26px);
  width: 52px;
  height: 52px;
  border-radius: 100%;
  background-color: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.link};
  transform: translateY(-25%);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TargetMsg = styled.div`
  position: absolute;
  top: 45px;
  left: calc(${({ left }) => left}% - 26px);
  width: fit-content;
`;

export const MobileQuiz = styled.div`
  border: 1px dashed ${(props) => props.theme.colors.link};
  border-radius: 4px;
  padding: 24px 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
`;
